window.mcb.driftstatus = window.mcb.driftstatus || {};
window.mcb.driftstatus.subscribe = (function () {
    const _logger = window.mcb.utilities.createLogger('driftstatus.subscribe', 'Drift Status Subscribe');
    const blocks = document.querySelectorAll('.mcb-webpart.driftstatus-block');
    const fieldNameIncidentId = 'incidentKey';
    const fieldNameServices = 'services';

    let formSubscribeToCase,
        formSubscribeToCaseModal,
        formSubscribeToCaseIncidentElement,
        formSubscribeToCaseServicesElements,
        formSubscribeToServices,
        formSubscribeToServicesModal;
    if (blocks.length > 0) {
        const followButtons = document.querySelectorAll('.opstat-subscribe');

        formSubscribeToCase = document.querySelector('.mcb-webform--type--subscribe-to-case');
        if (formSubscribeToCase) {
            formSubscribeToCaseModal = window.mcb.modalizer.wrap(formSubscribeToCase);
            formSubscribeToCaseIncidentElement = formSubscribeToCaseModal.querySelector('input[name="' + fieldNameIncidentId + '"]');
            formSubscribeToCaseServicesElements = formSubscribeToCaseModal.querySelectorAll('input[name="' + fieldNameServices + '"]');
            formSubscribeToCaseModal.addEventListener('MCB.Events.Modal.Closed', function (e) {
                _logger.log('Clear Form Data');
                formSubscribeToCaseIncidentElement.value = null;
                formSubscribeToCaseServicesElements.forEach((el) => {
                    el.closest('label').classList.remove('opstat-highlight');
                });

                location.reload();
            }, false);

            followButtons.forEach((el) => {
                el.addEventListener("click", function (e) {
                    e.preventDefault();

                    const link = e.target.closest('.opstat-subscribe');
                    const id = link.dataset.incidentKey;

                    _logger.log('Set Status Id to ', id);
                    formSubscribeToCaseIncidentElement.value = id;

                    const services = JSON.parse(link.dataset.serviceKeys);
                    _logger.log('Set Services to', services);
                    formSubscribeToCaseServicesElements.forEach((el) => {
                        if (services.indexOf(el.value) >= 0) {
                            el.closest('label').classList.add('opstat-highlight');
                        }
                    });

                    window.mcb.modalizer.openModal(formSubscribeToCaseModal);
                });
            });
        }
        else if (followButtons.length > 0) {
            _logger.error('Subscribe to case form not found');
            document.querySelectorAll('.opstat-subscribe-header').forEach((el) => {
                el.classList.add('mcb-hidden');
            });
            followButtons.forEach((el) => {
                el.classList.add('mcb-hidden');
            });
        }

        formSubscribeToServices = document.querySelector('.mcb-webform--type--subscribe-to-services');
        if (formSubscribeToServices) {
            formSubscribeToServicesModal = window.mcb.modalizer.wrap(formSubscribeToServices);

            formSubscribeToServicesModal.addEventListener('MCB.Events.Modal.Closed', function (e) {
                location.reload();
            }, false);

            document.querySelectorAll('.opstat-subscribe-services-form-activator').forEach((el) => {
                el.addEventListener("click", function (e) {
                    e.preventDefault();

                    window.mcb.modalizer.openModal(formSubscribeToServicesModal);
                });
            })
        }
    }
})();
